import {useState, useEffect} from 'react';
import './doubleSixes.css';
import ShowDoubleSixesList from './showDoubleSixesList';
import SolveDoubleSixes from './solveDoubleSixes';
import setFromJsonFile from '../../functions/setFromJsonFile';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { getSixpacks } from '../../functions/callApi';
import SolveOneDoubleSix from './solveOneDoubleSix';

const DoubleSixes=() => {
    const [diy, setDiy] = useState(false);
    const [diyId, setDiyId] = useState(-1);
    const [diyData, setDiyData] = useState({error: 'No puzzle made yet'});
    const [diyLetters, setDiyLetters] = useState('');
    const [doubleSixesList, setDoubleSixesList] = useState([]);
    const [doubleSixesIndex, setDoubleSixesIndex] = useState(-1);
    const [doubleSixesDesc, setDoubleSixesDesc] = useState('Item not selected');
    const getDoubleSixesList=()=>{
        setFromJsonFile('doublesixes/doubleSixesList.json', setDoubleSixesList, true);
    }

    useEffect(()=>{
        getDoubleSixesList();
    },[])
    async function submitDiyLetters(event) {
        event.preventDefault();
        let response = await getSixpacks('NWL2023', diyLetters);
        if (!response.error) {
            let answers = [];
            response.forEach(pair => {
                let pairSplit = pair.toUpperCase().split(",");
                answers.push({word1: pairSplit[0], word2: pairSplit[1]});
            });
            setDiyData({id: 1, phrase: diyLetters.toUpperCase(), answers: answers});
            setDiyId(1);
        }
    }
    const DoItYourself = <div>
        <h1>Make your own puzzle</h1>
        <button className='btn btn-secondary' onClick={() => {setDiy(false);}}>Return to premade puzzles</button>
        {diyData.error && <h2>{diyData.error}</h2>}
        <Form onSubmit={submitDiyLetters}>
            <InputGroup>
                <Form.Control
                type="text"
                value={diyLetters}
                onChange={e => { setDiyLetters(e.target.value); } }
                placeholder="Your 12 letters..."
                autoComplete='false'
                />
                <Button variant="primary" type='submit'>Submit</Button>
            </InputGroup>
        </Form>
        {diyId > 0 && <SolveOneDoubleSix data={diyData} setItemid={setDiyId} currentId={diyId} maxId={1}/>}
    </div>
    return (<div className='doubleSixes'>
        {!diy && doubleSixesIndex < 0 &&
            <div>
                <button className='btn btn-secondary' onClick={() => {setDiy(true);}}>Make your own puzzle</button>
            </div>
        }
        {!diy && doubleSixesIndex > -1 &&
            <ul className="list-group list-group-horizontal">
                <li className="list-group-item list-group-item-info">{doubleSixesDesc}</li>
                <li className="list-group-item list-group-item-info">
                    <button className='btn btn-dark' onClick={() => { setDoubleSixesIndex(-1); } }>Quit this item</button>
                </li>
            </ul>
        }
        {!diy && doubleSixesList && doubleSixesList.length && doubleSixesIndex < 0 &&
            <ShowDoubleSixesList doubleSixesList={doubleSixesList} setDoubleSixesIndex={setDoubleSixesIndex} setDoubleSixesDesc={setDoubleSixesDesc} />
        }
        {!diy && doubleSixesIndex > -1 &&
            <SolveDoubleSixes filename={`doublesixes/${doubleSixesList[doubleSixesIndex].lexicon}/${doubleSixesList[doubleSixesIndex].filename}`}/>
        }
        {diy && DoItYourself}
    </div>);
}

export default DoubleSixes;